import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextRegular } from 'UiKit/typography';
import ButtonLink from 'UiKit/button/buttonLink';
import { RedoIcon } from 'Asset/icon';

import { useScheduleGenerateState } from 'View/schedule-generate/state';

import styles from './styles.module.css';

const CalendarHead = ({ showWeek, weekInfo, firstWeek }) => {
  const { t } = useTranslation('schedule-generate');
  const { accounts, updateState, selectedTab, generateResultData } = useScheduleGenerateState();
  const initialAccount = generateResultData?.accounts;
  const currentShowWeek = showWeek - firstWeek + 1;

  const handleReset = () => {
    const accountIndex = accounts.findIndex((account) => account.type === selectedTab);
    const currentAccount = accounts[accountIndex];
    const { datas } = currentAccount;
    const weekIndex = accounts[accountIndex]?.datas.findIndex((data) => data.week === showWeek);

    datas[weekIndex] = {
      ...datas[weekIndex],
      schedules: initialAccount[accountIndex]?.datas[weekIndex]?.schedules,
    };

    accounts[accountIndex] = {
      ...accounts[accountIndex],
      datas,
    };

    updateState({
      accounts,
    });
  };

  return (
    <Box className={styles['generate-result-calendar__section--header']}>
      <TextBold className={styles['calendar__header--left']}>{t('weeksText', { week: currentShowWeek })}</TextBold>
      <Box className={styles['calendar__header--right']}>
        <ButtonLink
          className={styles['calendar__header--right-button']}
          leftIcon={<RedoIcon width="14px" height="14px" color="var(--color-primary60)" />}
          onClick={handleReset}
        >
          Reset
        </ButtonLink>

        <TextRegular className={styles['calendar__header--right-text']}>
          {currentShowWeek}/{weekInfo?.weeksInMonth - firstWeek + 1}
        </TextRegular>
      </Box>
    </Box>
  );
};

export default CalendarHead;
